import script from "./RichTextEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./RichTextEditor.vue?vue&type=script&setup=true&lang=js"

import "./RichTextEditor.vue?vue&type=style&index=0&id=f934c114&scoped=true&lang=css"
import "./RichTextEditor.vue?vue&type=style&index=1&id=f934c114&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f934c114"]])

export default __exports__